/** @jsxImportSource @emotion/react */

import React, { FC } from "react";
import DefaultLayout from "ui-modules/components/Layout/DefaultLayout";
import { useHistory } from "react-router-dom";
import ContainerFluid from "ui-modules/components/Layout/ContainerFluid";
// import emailOutline from "@iconify/icons-mdi/email-outline";
import accountOutline from "@iconify/icons-mdi/account-outline";
import Img from "ui-modules/components/Image/Img";
import zitelLogo from "../assets/images/ztel.png";
import rest from "../utils/rest";
import { localRemoveItem, sessionRemoveItem } from "../utils/storage";
import { PROMOTION_BANNER_DISMISSED_KEY } from "../components/BannerWinter/BannerWinter";
import useGlobal from "ui-modules/commons/hooks/use-global";
// import { modalStorage } from "../components/PopUp/PopUp";
// import AppModal from "../components/AppModal";
import Icon from "../components/Icon";
import Tooltip from "ui-modules/components/DataDisplay/Tooltip";
import TopAppBarNotification from "../components/Notifications/TopAppBarNotification";

type CustomerLayoutTypes = {
  title?: string;
  balanceMe?: number;
  lastUnReadMsgMe?: Record<any, any>[];
};

const CustomerLayout: FC<CustomerLayoutTypes> = (props) => {
  // const tourGuideStorage = SimpleStorage.getOrCreate<boolean>("tourGuide", true);

  // const [openTour, setOpenTour] = useState(tourGuideStorage.get());

  const { me = {}, readAllNotification } = useGlobal()?.global || {};

  const history = useHistory();

  const { children, title = "سامانه مشترکین زی‌تل", balanceMe = 0, lastUnReadMsgMe = [] } = props;

  const handleRedirectProfile = () => history.push("/profile");

  const handleChangePassword = () => history.push("/change-password");

  // const handleIntroduction = () => history.push("/introduction");

  const handleExit = () => {
    rest
      .delete(`${process.env.REACT_APP_AUTH_SERVICE}/auth/revoke`)
      .then(() => {
        localRemoveItem();
        sessionRemoveItem();
        try {
          localStorage.removeItem(PROMOTION_BANNER_DISMISSED_KEY);
        } catch (_) {}
        history.replace("/auth/login");
        // modalStorage.set(true);
        // tourGuideStorage.set(false);
      })
      .catch(() => {
        localRemoveItem();
        sessionRemoveItem();
        try {
          localStorage.removeItem(PROMOTION_BANNER_DISMISSED_KEY);
        } catch (_) {}
        history.replace("/auth/login");
      });
  };

  const handleOpenWebSite = () => window.open("https://www.zi-tel.com/");

  const handleTickets = () => history.push("/support/tickets-list");

  // const restartTour = () => {
  //   setOpenTour(!openTour);
  //   tourGuideStorage.set(false);
  // };
  //
  // const tourItems = {
  //   steps: [
  //     {
  //       target: ".appBar-website",
  //       content: "انتقال به وب‌سایت زیتل",
  //       showSkipButton: true,
  //       stepIndex: 0,
  //       // disableBeacon: true,
  //     },
  //     {
  //       target: ".appBar-invite",
  //       content: "دسترسی به کد هدیه و کد معرف",
  //       showSkipButton: true,
  //       stepIndex: 1,
  //     },
  //     {
  //       target: ".theme-switch",
  //       content: "تغییر تم (روشن و تیره) پنل کاربری",
  //       showSkipButton: true,
  //       stepIndex: 2,
  //     },
  //     {
  //       target: ".top-app-bar-notfication",
  //       content: "مشاهده آخرین اعلان‌ها",
  //       showSkipButton: true,
  //       stepIndex: 3,
  //     },
  //     {
  //       target: ".appBar-tickets",
  //       content: "دسترسی سریع به صفحه تیکت‌ها (ایجاد و مشاهده درخواست‌ها)",
  //       showSkipButton: true,
  //       stepIndex: 4,
  //     },
  //     {
  //       target: ".appBar-profile-menu",
  //       content: "دسترسی به اطلاعات کاربری، تغییر رمز عبور و خروج از پنل کاربری",
  //       showSkipButton: true,
  //       stepIndex: 5,
  //       // placement: 'left',
  //     },
  //     {
  //       target: ".sidebar-menu-home",
  //       content: "دسترسی سریع به صفحه اول پنل کاربری",
  //       showSkipButton: true,
  //     },
  //     {
  //       target: ".sidebar-menu-services",
  //       content: "مشاهده جزيیات سرویس‌ها و تمدید سرویس",
  //       showSkipButton: true,
  //       stepIndex: 6,
  //     },
  //     {
  //       target: ".sidebar-menu-support",
  //       content: "ارتباط با تیم پشتیبانی از طریق ثبت تیکت و مشاهده سوابق تیکت‌ها",
  //       showSkipButton: true,
  //     },
  //     {
  //       target: ".sidebar-menu-financial",
  //       content: "امکان مشاهده بدهی‌ها، فاکتورها، فهرست ودیعه، پرداخت و چاپ سندهای مالی",
  //       showSkipButton: true,
  //     },
  //     {
  //       target: ".sidebar-menu-speedTest",
  //       content: "تست سرعت اینترنت و مشاهده سوابق در بازه‌های زمانی انجام شده",
  //       showSkipButton: true,
  //     },
  //     {
  //       target: ".sidebar-menu-help",
  //       content: "مشاهده سوالات متدوال در خصوص نحوه نصب و راه اندازی سرویس، دانلود فایل‌های آموزشی",
  //       showSkipButton: true,
  //     },
  //   ],
  // };

  let topAppBarTitle: any = [
    {
      title: "وبسایت",
      align: "start",
      onClick: handleOpenWebSite,
      showOnMobile: false,
      className: "appBar-website",
    },
    {
      render: () => {
        return (
          <Tooltip title="اعلان‌ها">
            <TopAppBarNotification messages={lastUnReadMsgMe} readAllNotification={readAllNotification} />
          </Tooltip>
        );
      },
      align: "end",
      showOnMobile: true,
    },
    /*{
      title: "معرفی به دوستان",
      align: "start",
      onClick: handleIntroduction,
      showOnMobile: false,
      className: "appBar-invite",
    },*/
    // {
    //   align: "start",
    //   onClick: restartTour,
    //   showOnMobile: false,
    //   icon: alertCircleOutline,
    // },
    balanceMe < 0
      ? {
          iconRender: (
            <Tooltip title="لطفا، جهت تسویه بدهی کلیک کنید.">
              <div>
                <Icon name={"paid"} className={"payment-dep-header-icon large"} />
              </div>
            </Tooltip>
          ),
          align: "end",
          onClick: () => history.replace("/financial/payment-debt"),
          showOnMobile: true,
        }
      : {},
    {
      // icon: emailOutline,
      iconRender: (
        <Tooltip title="تیکت ها">
          <div>
            <Icon name={"tickets"} className={"drawerIcons large"} />
          </div>
        </Tooltip>
      ),
      align: "end",
      onClick: handleTickets,
      showOnMobile: true,
      className: "appBar-tickets",
    },
    { showChangeTheme: true, showOnMobile: true },
  ];
  return (
    <DefaultLayout
      appBar={{
        topAppBarTitle,
        menu: {
          title: me?.party?.fullName || "",
          hideTitleInMobile: true,
          className: "appBar-profile-menu",
          onlyInMobile: [
            {
              title: me?.party?.fullName || "",
              divider: true,
            },
          ],
          icon: accountOutline,
          items: [
            { title: "اطلاعات کاربری", divider: true, onClick: handleRedirectProfile },
            { title: "تغییر رمز عبور", divider: true, onClick: handleChangePassword },
            { title: "خروج", onClick: handleExit },
          ],
        },
      }}
      sideBar={{
        headerIcon: <Img alt="Logo" src={zitelLogo} customCSS={"width: 15px;"} />,
        headerTitle: title,
      }}
    >
      <ContainerFluid>{children}</ContainerFluid>
      {/*<AppModal />*/}
      {/*{window.innerWidth > 852 ? (*/}
      {/*  <TourGuide run={openTour} disableCloseOnEsc onFinished={restartTour} steps={tourItems.steps} />*/}
      {/*) : null}*/}
    </DefaultLayout>
  );
};
export default CustomerLayout;
